import _ from 'lodash'
import { MyActivePermissions } from '@/helpers/my-account-helper'

export function requireOrganizationMembership(to, from, next) {
  _checkOrganization(to, from, next, MyActivePermissions)
}

// Note that this function requires that ANY of the permissions be met, not all
export function requirePermissions(to, from, next, permissions) {
  if (_.intersection(MyActivePermissions, permissions).length > 0) {
    requireOrganizationMembership(to, from, next)
  } else {
    next('/')
  }
}

function _checkOrganization(to, from, next, permissions) {
  if (_.isEmpty(permissions)) {
    next('/no-membership')
  } else {
    next()
  }
}
